import BithidePaymentInfo from './BithidePaymentInfo';
export default BithidePaymentInfo;
